module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ed-input-item', {
    attrs: {
      "label": _vm.label,
      "info": _vm.info,
      "name": _vm.name,
      "required": _vm.required
    }
  }, [_c('el-select', {
    attrs: {
      "value": _vm.value,
      "clearable": _vm.clearable,
      "loading": _vm.loading,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled ? true : false,
      "multiple": _vm.multiple,
      "value-key": _vm.itemValue,
      "remote-method": _vm.remoteMethod,
      "collapse-tags": "",
      "remote": "",
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$emit('input', $event)
      },
      "input": function($event) {
        return _vm.$emit('input', $event)
      }
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": _vm.getLabel(item),
        "value": _vm.getValue(item)
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.getHtml(item))
      }
    })])
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6184d0f7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/EdInputAutoComplete.vue
// module id = 1443
// module chunks = 45